export default __webpack_public_path__ + "static/media/tour.7bade878.svg";